import { ChevronLeft } from "lucide-react";
import React, { useEffect, useMemo, useState } from "react";
import Googlemap2 from "../common/GoogleMap/Googlemap2";
import axiosInstance from "../../apiInstances/axiosInstance";
import PropertyCard from "../common/PropertyCard/PropertyCard";
import CollectionPropertyCard from "./CollectionPropertyCard";

function NearbyCollection() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [nearbyProperties, setNearbyProperties] = useState([]);

  const getPropertyStatus = (p) => {
    const s = (p?.property?.status || p?.propertyId?.status || p?.status || "")
      .toString()
      .toLowerCase();
    if (s.includes("sold")) return "Sold";
    if (s.includes("active")) return "Buy";
    if (s.includes("rent") || s.includes("lease")) return "Rent";
    if (s.includes("inspect")) return "Inspected";
    return "Buy";
  };

  const filteredProperties = useMemo(() => {
    if (activeFilter === "All") return nearbyProperties;
    return nearbyProperties.filter(
      (p) => getPropertyStatus(p) === activeFilter,
    );
  }, [activeFilter, nearbyProperties]);


  useEffect(() => {
    const getNearbyProperties = async (lat, lng) => {
      const response = await axiosInstance.post("/nearByProperties", {
        lat,
        lng,
      });
      setNearbyProperties(response.data.data);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          getNearbyProperties(lat, lng);
        },
        (error) => {
          console.error("Location error:", error);
          getNearbyProperties(25.3178434, 55.3748703);
        }
      );
    } else {
      console.error("Geolocation not supported");
      // fallback
      getNearbyProperties(25.3178434, 55.3748703);
    }
  }, []);

  return (
    <div className="bg-[#F3F6F9]">
      <div className="container mx-auto flex flex-col lg:flex-row">
        <div className="px-4 py-10 w-full lg:w-1/2">
          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-1 text-[#097FE6] font-medium hover:underline"
          >
            <ChevronLeft className="w-5 h-5" strokeWidth={2} />
            Back to collection
          </button>

          <div className="flex flex-col lg:flex-row gap-10 mt-5">
            <div className="flex-1">
              <div className="mb-3 flex items-center justify-between">
                <div>
                  <h1 className="text-2xl sm:text-3xl font-semibold text-[#000929] mb-3">
                    Nearby Me
                  </h1>
                  <p className="text-sm text-gray-500">
                    Showing {filteredProperties.length} properties
                  </p>
                </div>
              </div>

              <div className="mt-5 mb-10 flex gap-2 overflow-x-auto scrollbar-hide bg-transparent lg:flex-wrap lg:overflow-visible">
                {["All", "Buy", "Rent", "Sold", "Inspected"].map(
                  (label) => (
                    <button
                      key={label}
                      type="button"
                      onClick={() => setActiveFilter(label)}
                      className={`flex-shrink-0 text-xs sm:text-sm rounded-full py-2.5 px-6 font-medium border transition-colors bg-white ${label === activeFilter
                        ? "border-[#000929] text-[#000929] border-2"
                        : "border-[#E0E3EB] text-gray-700 hover:bg-[#ebedf2]"
                        }`}
                    >
                      {label}
                    </button>
                  ),
                )}
              </div>

              {nearbyProperties.length === 0 && (
                <div className="bg-[#E6EAEE] rounded-3xl min-h-[380px] flex flex-col items-center justify-center text-center px-8">
                  <div className="mb-5 inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-sm">
                    <span className="text-2xl text-[#097FE6]">📄</span>
                  </div>
                  <h2 className="text-xl font-semibold text-[#000929] mb-2">
                    Collect your favourites
                  </h2>
                  <p className="text-sm text-gray-600 mb-6 max-w-sm">
                    Tap the star on any property to add it to this Collection.
                  </p>
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-full bg-[#097FE6] px-7 py-3 text-sm font-medium text-white shadow-sm hover:bg-[#0664b7] transition-colors"
                  >
                    Start browsing
                  </button>
                </div>
              )}

              {nearbyProperties.length > 0 && filteredProperties.length === 0 && (
                <div className="bg-[#E6EAEE] rounded-3xl min-h-[380px] flex flex-col items-center justify-center text-center px-8">
                  <h2 className="text-xl font-semibold text-[#000929] mb-2">
                    No properties found
                  </h2>
                  <p className="text-sm text-gray-600">
                    Try another filter.
                  </p>
                </div>
              )}

              {filteredProperties.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 overflow-y-auto">
                  {filteredProperties.map((property) => (
                    <CollectionPropertyCard key={property._id} property={property} />
                  ))}
                </div>
              )}
            </div>

          </div>
        </div>
        <div className="w-full lg:w-1/2 flex-1 flex">
          <div className="w-full min-h-[380px] lg:min-h-[540px]  bg-[#E3E5E6] overflow-hidden border border-gray-200 flex">
            <Googlemap2 style={{ height: "100%" }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NearbyCollection;
